export const cargoNumberWithReference = cargo => {
	const elements = [ cargo.cargoNumber ? cargo.cargoNumber : cargo.product?.name ];
	if (cargo.loadingReference) {
		elements.push(`LR: ${cargo.loadingReference}`);
	}
	if (cargo.dischargingReference) {
		elements.push(`DR: ${cargo.dischargingReference}`);
	}
	return elements.join(" - ");
};
